import { DialogTitle } from '@radix-ui/react-dialog'
import React from 'react'

import Icon from '../../../atoms/icons/icon/Icon'

export const ProposalAdvisorConversationMobileHeader = ({
  title,
  onClose,
}: {
  title: string
  onClose: () => void
}) => {
  return (
    <header className='flex w-full flex-row items-center justify-between p-5'>
      <DialogTitle className='text-base font-medium'>{title}</DialogTitle>
      <Icon
        className='h-3 w-3'
        name='cross-without-circle'
        color='black'
        style={{ cursor: 'pointer' }}
        onClick={() => onClose?.()}
      />
    </header>
  )
}
